"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = void 0;

var _stylitas = require("@creditas/stylitas");

var _typography = require("@creditas-lab/typography");

var _styleUtilities = require("@creditas-lab/style-utilities");

var Description = (0, _stylitas.styled)(_typography.Typography)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 80%;\n  line-height: 20px;\n\n  ", "\n"])), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    line-height: 24px;\n  "]))));
exports.Description = Description;